export default __webpack_public_path__ + "static/media/1-logos-backend.993b1e26.webp";